import { render, staticRenderFns } from "./PermisosUsuario.vue?vue&type=template&id=a69a7558"
import script from "./PermisosUsuario.vue?vue&type=script&lang=js"
export * from "./PermisosUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports